// extracted by mini-css-extract-plugin
export default {"modal":"modal-wTvl0u","left":"left-DCFy4H","right":"right-jX6Xnd","title":"title-BgBC7t","content":"content-JVOtCN","end":"end-TmiWIi"};